import { FC } from "react";
import { Box, Flex, Grid, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { DECKS, DeckDef } from "@lubbezposrednio-frontend/core";

// Rozdroże prezentacji — kafelki wszystkich decków (gotowe + „wkrótce").
export const PresentationsIndexView: FC = () => {
  const navigate = useNavigate();

  return (
    <Flex minH="100vh" align="center" justify="center" bg="#1A1033" p="28px">
      <VStack spacing="26px" maxW="1120px" w="100%" align="stretch">
        <VStack spacing="6px" textAlign="center">
          <Text color="#FFD23F" fontWeight="800" letterSpacing="0.18em" textTransform="uppercase" fontSize="14px">
            Prezentacje · lubbezpośrednio.pl
          </Text>
          <Heading color="#fff" fontSize={{ base: "30px", md: "44px" }} fontWeight="900">
            Wybierz prezentację
          </Heading>
        </VStack>

        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap="18px">
          {DECKS.map((d) => (
            <DeckCard
              key={d.id}
              deck={d}
              onOpen={() => navigate(`/prezentacja/${d.slug}`)}
              onPresenter={() => window.open(`/prezentacja/${d.slug}/prezenter`, "prezenter", "width=1100,height=720")}
            />
          ))}
        </Grid>

        <Text color="rgba(255,255,255,0.55)" fontSize="13px" textAlign="center">
          Sterowanie: ← → / spacja — nawigacja · F — pełny ekran · O — siatka slajdów · P — notatki · 1–9 — skok
        </Text>
      </VStack>
    </Flex>
  );
};

const DeckCard: FC<{ deck: DeckDef; onOpen: () => void; onPresenter: () => void }> = ({ deck, onOpen, onPresenter }) => {
  const ready = !!deck.ready;
  return (
    <VStack
      align="flex-start"
      spacing="11px"
      bg="rgba(255,255,255,0.06)"
      border="1px solid rgba(255,255,255,0.16)"
      borderRadius="20px"
      p="22px"
      opacity={ready ? 1 : 0.62}
      minH="218px"
    >
      <HStack justify="space-between" w="100%">
        <Text color="#FFD23F" fontWeight="800" fontSize="12px" textTransform="uppercase" letterSpacing="0.1em">
          {deck.estimatedMin ? `~${deck.estimatedMin} min` : "prezentacja"}
        </Text>
        {!ready && (
          <Text fontSize="11px" color="rgba(255,255,255,0.5)" fontWeight="800" letterSpacing="0.08em">
            WKRÓTCE
          </Text>
        )}
      </HStack>
      <Heading color="#fff" fontSize="21px" fontWeight="800" lineHeight="1.15" noOfLines={2}>
        {deck.title}
      </Heading>
      <Text color="rgba(255,255,255,0.72)" fontSize="14px" lineHeight="1.4" noOfLines={3} flex="1">
        {deck.subtitle}
      </Text>
      <HStack pt="4px" spacing="10px">
        <Box
          as="button"
          onClick={ready ? onOpen : undefined}
          bg={ready ? "#E51F44" : "rgba(255,255,255,0.12)"}
          color="#fff"
          fontWeight="800"
          fontSize="14px"
          px="18px"
          py="10px"
          borderRadius="full"
          cursor={ready ? "pointer" : "not-allowed"}
        >
          {ready ? "Otwórz" : "Wkrótce"}
        </Box>
        {ready && (
          <Box as="button" onClick={onPresenter} bg="rgba(255,255,255,0.12)" color="#fff" fontWeight="700" fontSize="14px" px="16px" py="10px" borderRadius="full">
            Prezenter
          </Box>
        )}
      </HStack>
    </VStack>
  );
};

export default PresentationsIndexView;
